import { render, staticRenderFns } from "./trimHandleTop.vue?vue&type=template&id=785db31d&"
import script from "./trimHandleTop.vue?vue&type=script&lang=ts&"
export * from "./trimHandleTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports